import type { RealizedStatus } from "@/api/types";
import type { TimesheetStatus } from "@/api/timesheets";

type ChipColor = "default" | "primary" | "info" | "success" | "warning" | "error";

/** Chip colour for a monthly timesheet period. Shared by the practitioner and manager views. */
export function timesheetStatusColor(s: TimesheetStatus): ChipColor {
  if (s === "VALIDATED") return "success";
  if (s === "PAID") return "info";
  if (s === "SUBMITTED") return "warning";
  if (s === "REJECTED") return "error";
  return "default";
}

/** Chip colour for a single shift's position on the prévisionnel → réalisé axis. */
export function realizedStatusColor(s: RealizedStatus): ChipColor {
  if (s === "DONE") return "success";
  if (s === "MODIFIED") return "warning";
  if (s === "ABSENT") return "error";
  if (s === "EXTRA") return "info";
  return "default";
}
